import {Base} from "@/api/Base"

export class PaymentList extends Base {
    path = "payment/list"
}